import Swiper from 'swiper';
import { Navigation } from "swiper/modules"

export function slider() {
    document.addEventListener('DOMContentLoaded', function() {
        const swiper = new Swiper('[data-slider]', {
            modules: [ Navigation ],
            direction: 'horizontal',
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            // releaseOnEdges: true,
            edgeSwipeDetection: 'prevent', //
            preventInteractionOnTransition: true, //
            // allowTouchMove: false, //
            centeredSlides: true,
            loop: true,
            speed: 1000,
            autoHeight: false,
            adaptiveHeight: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              observer: true,
              observeParents: true,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    centeredSlides: false,
                    autoHeight: true

                },
                768: {
                    slidesPerView: 3,
                    centeredSlides: true,
                    autoHeight: true

                }
            }
        });
    });
}